<div class="insurance-container">
  <div>
    <div class="secondTitle">
      <h2 appConfigSettingsSecondTitle>{{'ApplicationPage.PurposeOfTheInsurance' | translate}}</h2>
    </div>
    <app-toggle-input
      appConfigSettingsInput
      class="full-width"
      placeholder="PurposeOfTheInsurance.MortgageRelated"
      [form]="applicationFormGroup.get('purposeOfTheInsurance')"
      [optionsList]="yesNoList"
      [control]="applicationFormGroup.get('purposeOfTheInsurance').get('mortgageRelated')"
    ></app-toggle-input>
  </div>
  <div>
    <div class="secondTitle">
      <h2 appConfigSettingsSecondTitle>{{'ApplicationPage.OtherInsurances' | translate}}</h2>
    </div>
    <app-toggle-input
      appConfigSettingsInput
      class="full-width"
      placeholder="OtherInsurances.Insured1HasInsurance"
      [form]="applicationFormGroup.get('otherInsurances1')"
      [optionsList]="yesNoList"
      [control]="
             applicationFormGroup
              .get('otherInsurances1')
              .get('insurerHasAnotherInsurer')"
    ></app-toggle-input>
    <ng-container
      *ngIf="applicationFormGroup.get('otherInsurances1').value.insurerHasAnotherInsurer == OptionsEnum.Yes"
    >
      <app-application-other-insurances
        [otherInsurancesFormGroup]="applicationFormGroup.get('otherInsurances1')"
      ></app-application-other-insurances>
    </ng-container>
    <app-toggle-input
      appConfigSettingsInput
      class="full-width"
      placeholder="OtherInsurances.Insured2HasInsurance"
      [form]="applicationFormGroup.get('otherInsurances2')"
      [optionsList]="yesNoList"
      [control]="
            applicationFormGroup
              .get('otherInsurances2')
              .get('insurerHasAnotherInsurer')"
      *ngIf="isSecondInsured"
    ></app-toggle-input>
    <ng-container
      *ngIf="isSecondInsured && applicationFormGroup.get('otherInsurances2').value.insurerHasAnotherInsurer == OptionsEnum.Yes"
    >
      <app-application-other-insurances
        [otherInsurancesFormGroup]="applicationFormGroup.get('otherInsurances2')"
      ></app-application-other-insurances>
    </ng-container>
  </div>
</div>
